export default "__VITE_ASSET__B8odJ49t__"